import { Newspaper } from 'lucide-react';
import { useLocation } from '../useLocation';

const COUNTRY_LABEL: Record<string, string> = {
  BW: 'Botswana',
  IN: 'India',
  ZA: 'South Africa',
  GB: 'UK',
  US: 'USA',
};

// Coming-soon placeholder. Seeded headlines were a quick visual aid but
// "live data only" rule says no. Real RSS aggregation lands later — until
// then the strip is clearly marked as not-yet-available so users don't
// mistake stale or invented headlines for current affairs.

export const NewsStrip = () => {
  const loc = useLocation();
  const label = COUNTRY_LABEL[loc.country.toUpperCase()] ?? loc.country.toUpperCase();

  return (
    <section
      aria-label={`${label} today`}
      aria-disabled="true"
      className="relative rounded-2xl border border-dashed border-line bg-bg-secondary/50 p-4 shadow-sm sm:p-5"
    >
      <span className="coming-soon-pulse absolute right-3 top-3 rounded-full bg-brand-orange/10 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-brand-orange">
        Coming soon
      </span>
      <div className="opacity-60">
        <div className="mb-2 flex items-center gap-2">
          <Newspaper className="h-4 w-4 text-text-tertiary" aria-hidden="true" />
          <h2 className="text-sm font-semibold tracking-tight text-text-tertiary">
            {label} today
          </h2>
        </div>
        <p className="text-xs text-text-tertiary">
          Local business + insurance headlines, refreshed every 30 minutes from
          trusted sources. Switching on once we wire the RSS aggregator.
        </p>
      </div>
    </section>
  );
};
